// language=GraphQL
export const ALL_PAGE_HEADER_BLOCKS_QUERY = `query Query($withImage: Boolean = false) {
  pageHeaderBlocks: cmsPageHeaderBlocks {
    id
    title
    text
    image @include(if: $withImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
  }
}`

// language=GraphQL
export const SINGLE_PAGE_HEADER_BLOCK_QUERY = `query Query($id: ID!, $withImage: Boolean = false) {
  pageHeaderBlock: cmsPageHeaderBlock(id: $id) {
    id
    title
    text
    image @include(if: $withImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
  }
}`

// language=GraphQL
export const CREATE_PAGE_HEADER_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsPageHeaderBlockInput, $withImage: Boolean = false) {
    pageHeaderBlock: createCmsPageHeaderBlock(input: $input) {
      id
      title
      text
      image @include(if: $withImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }`

// language=GraphQL
export const UPDATE_PAGE_HEADER_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsPageHeaderBlockInput, $withImage: Boolean = false) {
    pageHeaderBlock: updateCmsPageHeaderBlock(input: $input) {
      id
      title
      text
      image @include(if: $withImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }`

// language=GraphQL
export const DELETE_PAGE_HEADER_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsPageHeaderBlockInput) {
    deleteCmsPageHeaderBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_PAGE_HEADER_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsPageHeaderBlockInput) {
    forceDeleteCmsPageHeaderBlock(input: $input) {
      success
    }
  }`
